module.exports = __webpack_public_path__ + "./kit/docs/img/slots-icon-warning.4b554235ffce9b8c992666f5488d13aa.svg";